import { createClient } from '../generated/api/client/client';
import General from '../utils/GeneralUtils';

/**
 * Configured API client for the NestJS API
 * 
 * This client is pre-configured with:
 * - Base URL pointing to the NestJS API Gateway endpoint (or localhost for development)
 * - JSON content type headers
 * - Automatic JWT token injection via request interceptor
 * - Error handling configuration
 */
const isLocalhost = window.location.hostname === 'localhost' || 
                   window.location.hostname === '127.0.0.1' ||
                   window.location.hostname === '[::1]';
const shouldUseLocalhost = true;

// VITE_API_BASE_URL is set per Superset workspace (see .superset/ports.mjs) so parallel
// workspaces each talk to their own API port instead of all racing for 3001.
const baseUrl = import.meta.env.VITE_API_BASE_URL
  ?? (isLocalhost && shouldUseLocalhost
    ? 'http://localhost:3001/v2'
    : 'https://api.getedulead.com/v2');

// Log which API endpoint is being used
console.log(`Edulead API Client initialized with baseUrl: ${baseUrl}`);

export const eduleadClient = createClient({
  baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  throwOnError: true,
});

// Add request interceptor to automatically inject Authorization header
eduleadClient.interceptors.request.use(async (request) => {
  // Get fresh JWT token for every request
  const authHeaders = await General.getAuthorizationHeaders();
  
  // Add Authorization header to the request
  request.headers.set('Authorization', authHeaders.Authorization);
  
  return request;
});
